import { convert } from "chromatism";

export function getColorToRGBA(color: string, opacity = 1) {
  const { r, g, b } = convert(color).rgb;

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}
